import api from "./axios";

export const getWarranties = () =>
  api.get("/warranties").then((res) => res.data);

export const getWarrantyPackageByName = (packageName) =>
  api.get(`/warranties?name=${packageName}`).then((res) => res.data);

export const upsertWarranty = (warrantyPackage) =>
  warrantyPackage._id
    ? api
        .put(`/warranties/${warrantyPackage._id}`, warrantyPackage)
        .then((res) => res.data)
    : api.post("/warranties", warrantyPackage).then((res) => res.data);

export const deleteWarranty = (id) => api.delete(`/warranties/${id}`);
